import { fetchApi } from "~/lib/api";
import type {
  AdminGetVoucherRedemptionsParams,
  AdminGetVouchersParams,
  Pagination,
  Voucher,
  VoucherCreateRequest,
  VoucherRedemptionWithDetails,
  VoucherRequest,
  VoucherRequestResponse,
  VoucherUpdateRequest,
  VoucherValidationResult,
  VoucherWithUser,
} from "~/types";
import { serializeFilterParams } from "./utils";

// Admin voucher service
export const adminVouchersService = {
  async getVouchers(params: AdminGetVouchersParams = {}) {
    const query = serializeFilterParams(params);

    return fetchApi<Pagination<VoucherWithUser>>(`/admin/vouchers${query}`);
  },

  async getVoucher(id: string) {
    return fetchApi<VoucherWithUser>(`/admin/vouchers/${id}`);
  },

  async createVoucher(data: VoucherCreateRequest) {
    return fetchApi<Voucher>("/admin/vouchers", {
      method: "POST",
      body: JSON.stringify(data),
    });
  },

  async updateVoucher(id: string, data: VoucherUpdateRequest) {
    return fetchApi<Voucher>(`/admin/vouchers/${id}`, {
      method: "PATCH",
      body: JSON.stringify(data),
    });
  },

  async deleteVoucher(id: string) {
    return fetchApi<{ message: string }>(`/admin/vouchers/${id}`, {
      method: "DELETE",
    });
  },

  async getRedemptions(params: AdminGetVoucherRedemptionsParams = {}) {
    const query = serializeFilterParams(params);

    return fetchApi<Pagination<VoucherRedemptionWithDetails>>(
      `/admin/vouchers/redemptions${query}`,
    );
  },
};

// Customer voucher service
export const customerVouchersService = {
  async validateVoucher(code: string, subtotal: number) {
    return fetchApi<VoucherValidationResult>("/customer/vouchers/validate", {
      method: "POST",
      body: JSON.stringify({ code, subtotal }),
    });
  },
};

export const anonymousVouchersService = {
  async requestVoucher(request: VoucherRequest) {
    return fetchApi<VoucherRequestResponse>("/anonymous/vouchers/request", {
      method: "POST",
      body: JSON.stringify(request),
    });
  },
};
